import { Command } from '@/app/common/base/command'
import { AuthData } from '@/app/auth/entities/auth-data.entity'

type TwoFactorMethod = 'totp' | 'email'

export class DisableTwoFactorCommand extends Command {
    public async run(code: string, method: TwoFactorMethod = 'totp') {
        const response = await this.client.post('/api/auth/two-factor', { code, enabled: false, method })

        const data = response.asObject() as Record<string, unknown>

        // Check for error response
        if (data?.error) {
            throw new Error((data.message as string) || 'Verification failed')
        }

        const authData = response.asEntity(AuthData)

        await this.store.dispatch('auth/updateTokens', {
            accessToken: authData.accessToken,
            refreshToken: authData.refreshToken,
        })
        await this.store.dispatch('auth/setTwoFactorStatus', { enabled: false })
    }
}
